// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/action/v1/action.proto" (package "c1.api.action.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { FormSchemaRef } from "../../form/v1/form";
/**
 * Action represents a workflow action that can be triggered
 *
 * @generated from protobuf message c1.api.action.v1.Action
 */
export interface Action {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: bool enabled = 2
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: string request_policy_id = 3
     */
    requestPolicyId: string;
    /**
     * @generated from protobuf field: c1.api.form.v1.FormSchemaRef form_schema_ref = 4
     */
    formSchemaRef?: FormSchemaRef;
    /**
     * @generated from protobuf oneof: visibility
     */
    visibility: {
        oneofKind: "everyone";
        /**
         * @generated from protobuf field: c1.api.action.v1.ActionVisibilityEveryone everyone = 100
         */
        everyone: ActionVisibilityEveryone;
    } | {
        oneofKind: "appEntitlementRefs";
        /**
         * @generated from protobuf field: c1.api.action.v1.AppEntitlementRefs app_entitlement_refs = 101
         */
        appEntitlementRefs: AppEntitlementRefs;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: target_ref
     */
    targetRef: {
        oneofKind: "workflowTemplateRef";
        /**
         * @generated from protobuf field: c1.api.action.v1.WorkflowTemplateRef workflow_template_ref = 200
         */
        workflowTemplateRef: WorkflowTemplateRef;
    } | {
        oneofKind: "batonResourceActionRef";
        /**
         * @generated from protobuf field: c1.api.action.v1.BatonResourceActionRef baton_resource_action_ref = 201
         */
        batonResourceActionRef: BatonResourceActionRef;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string request_instructions = 5
     */
    requestInstructions: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 8
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string display_name = 9
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionVisibilityEveryone
 */
export interface ActionVisibilityEveryone {
}
/**
 * WorkflowTemplateRef is a reference to a workflow template
 *
 * @generated from protobuf message c1.api.action.v1.WorkflowTemplateRef
 */
export interface WorkflowTemplateRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * ActionRef is a reference to an Action
 *
 * @generated from protobuf message c1.api.action.v1.ActionRef
 */
export interface ActionRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * BatonResourceActionRef is a reference to a Baton resource action
 *
 * @generated from protobuf message c1.api.action.v1.BatonResourceActionRef
 */
export interface BatonResourceActionRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string baton_action_name = 4
     */
    batonActionName: string;
    /**
     * @generated from protobuf field: string baton_action_display_name = 5
     */
    batonActionDisplayName: string;
}
/**
 * @generated from protobuf message c1.api.action.v1.AppEntitlementRefs
 */
export interface AppEntitlementRefs {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef refs = 1
     */
    refs: AppEntitlementRef[];
}
/**
 * Request/Response messages for ActionService
 *
 * @generated from protobuf message c1.api.action.v1.ActionServiceCreateRequest
 */
export interface ActionServiceCreateRequest {
    /**
     * @generated from protobuf field: bool enabled = 1
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: string request_policy_id = 2
     */
    requestPolicyId: string;
    /**
     * @generated from protobuf field: c1.api.form.v1.FormSchemaRef form_schema_ref = 3
     */
    formSchemaRef?: FormSchemaRef;
    /**
     * @generated from protobuf oneof: visibility
     */
    visibility: {
        oneofKind: "everyone";
        /**
         * @generated from protobuf field: c1.api.action.v1.ActionVisibilityEveryone everyone = 100
         */
        everyone: ActionVisibilityEveryone;
    } | {
        oneofKind: "appEntitlementRefs";
        /**
         * @generated from protobuf field: c1.api.action.v1.AppEntitlementRefs app_entitlement_refs = 101
         */
        appEntitlementRefs: AppEntitlementRefs;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: target_ref
     */
    targetRef: {
        oneofKind: "workflowTemplateRef";
        /**
         * @generated from protobuf field: c1.api.action.v1.WorkflowTemplateRef workflow_template_ref = 200
         */
        workflowTemplateRef: WorkflowTemplateRef;
    } | {
        oneofKind: "batonResourceActionRef";
        /**
         * @generated from protobuf field: c1.api.action.v1.BatonResourceActionRef baton_resource_action_ref = 201
         */
        batonResourceActionRef: BatonResourceActionRef;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string request_instructions = 4
     */
    requestInstructions: string;
    /**
     * @generated from protobuf field: string display_name = 5
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceCreateResponse
 */
export interface ActionServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.action.v1.Action action = 1
     */
    action?: Action;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceGetRequest
 */
export interface ActionServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceGetResponse
 */
export interface ActionServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.action.v1.Action action = 1
     */
    action?: Action;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceListRequest
 */
export interface ActionServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.action.v1.ActionRef refs = 3
     */
    refs: ActionRef[];
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceListResponse
 */
export interface ActionServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.action.v1.Action actions = 1
     */
    actions: Action[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceUpdateRequest
 */
export interface ActionServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.action.v1.Action action = 1
     */
    action?: Action;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceUpdateResponse
 */
export interface ActionServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.action.v1.Action action = 1
     */
    action?: Action;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceDeleteRequest
 */
export interface ActionServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceDeleteResponse
 */
export interface ActionServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceSearchRequest
 */
export interface ActionServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.action.v1.ActionRef refs = 4
     */
    refs: ActionRef[];
    /**
     * @generated from protobuf field: repeated string app_ids = 5
     */
    appIds: string[];
    /**
     * @generated from protobuf field: c1.api.action.v1.ActionTargetRefTypeFilter target_ref_type_filter = 6
     */
    targetRefTypeFilter?: ActionTargetRefTypeFilter;
    /**
     * Filter actions by enabled status. If not set, returns all actions.
     *
     * @generated from protobuf field: optional bool enabled = 7
     */
    enabled?: boolean;
}
/**
 * Filter actions by target reference type without requiring specific IDs
 *
 * @generated from protobuf message c1.api.action.v1.ActionTargetRefTypeFilter
 */
export interface ActionTargetRefTypeFilter {
    /**
     * @generated from protobuf oneof: target_ref_type
     */
    targetRefType: {
        oneofKind: "workflowTemplate";
        /**
         * @generated from protobuf field: c1.api.action.v1.WorkflowTemplateRefFilter workflow_template = 1
         */
        workflowTemplate: WorkflowTemplateRefFilter;
    } | {
        oneofKind: "batonResourceAction";
        /**
         * @generated from protobuf field: c1.api.action.v1.BatonResourceActionRefFilter baton_resource_action = 2
         */
        batonResourceAction: BatonResourceActionRefFilter;
    } | {
        oneofKind: undefined;
    };
}
/**
 * Filter for actions targeting workflow templates
 *
 * @generated from protobuf message c1.api.action.v1.WorkflowTemplateRefFilter
 */
export interface WorkflowTemplateRefFilter {
}
/**
 * Filter for actions targeting baton resource actions
 *
 * @generated from protobuf message c1.api.action.v1.BatonResourceActionRefFilter
 */
export interface BatonResourceActionRefFilter {
}
/**
 * @generated from protobuf message c1.api.action.v1.ActionServiceSearchResponse
 */
export interface ActionServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.action.v1.Action list = 1
     */
    list: Action[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Action$Type extends MessageType<Action> {
    constructor() {
        super("c1.api.action.v1.Action", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "request_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "form_schema_ref", kind: "message", T: () => FormSchemaRef },
            { no: 100, name: "everyone", kind: "message", oneof: "visibility", T: () => ActionVisibilityEveryone },
            { no: 101, name: "app_entitlement_refs", kind: "message", oneof: "visibility", T: () => AppEntitlementRefs },
            { no: 200, name: "workflow_template_ref", kind: "message", oneof: "targetRef", T: () => WorkflowTemplateRef },
            { no: 201, name: "baton_resource_action_ref", kind: "message", oneof: "targetRef", T: () => BatonResourceActionRef },
            { no: 5, name: "request_instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<Action>): Action {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.enabled = false;
        message.requestPolicyId = "";
        message.visibility = { oneofKind: undefined };
        message.targetRef = { oneofKind: undefined };
        message.requestInstructions = "";
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<Action>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Action): Action {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool enabled */ 2:
                    message.enabled = reader.bool();
                    break;
                case /* string request_policy_id */ 3:
                    message.requestPolicyId = reader.string();
                    break;
                case /* c1.api.form.v1.FormSchemaRef form_schema_ref */ 4:
                    message.formSchemaRef = FormSchemaRef.internalBinaryRead(reader, reader.uint32(), options, message.formSchemaRef);
                    break;
                case /* c1.api.action.v1.ActionVisibilityEveryone everyone */ 100:
                    message.visibility = {
                        oneofKind: "everyone",
                        everyone: ActionVisibilityEveryone.internalBinaryRead(reader, reader.uint32(), options, (message.visibility as any).everyone)
                    };
                    break;
                case /* c1.api.action.v1.AppEntitlementRefs app_entitlement_refs */ 101:
                    message.visibility = {
                        oneofKind: "appEntitlementRefs",
                        appEntitlementRefs: AppEntitlementRefs.internalBinaryRead(reader, reader.uint32(), options, (message.visibility as any).appEntitlementRefs)
                    };
                    break;
                case /* c1.api.action.v1.WorkflowTemplateRef workflow_template_ref */ 200:
                    message.targetRef = {
                        oneofKind: "workflowTemplateRef",
                        workflowTemplateRef: WorkflowTemplateRef.internalBinaryRead(reader, reader.uint32(), options, (message.targetRef as any).workflowTemplateRef)
                    };
                    break;
                case /* c1.api.action.v1.BatonResourceActionRef baton_resource_action_ref */ 201:
                    message.targetRef = {
                        oneofKind: "batonResourceActionRef",
                        batonResourceActionRef: BatonResourceActionRef.internalBinaryRead(reader, reader.uint32(), options, (message.targetRef as any).batonResourceActionRef)
                    };
                    break;
                case /* string request_instructions */ 5:
                    message.requestInstructions = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 7:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 8:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* string display_name */ 9:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Action, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool enabled = 2; */
        if (message.enabled !== false)
            writer.tag(2, WireType.Varint).bool(message.enabled);
        /* string request_policy_id = 3; */
        if (message.requestPolicyId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.requestPolicyId);
        /* c1.api.form.v1.FormSchemaRef form_schema_ref = 4; */
        if (message.formSchemaRef)
            FormSchemaRef.internalBinaryWrite(message.formSchemaRef, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string request_instructions = 5; */
        if (message.requestInstructions !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.requestInstructions);
        /* google.protobuf.Timestamp created_at = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 7; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 8; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 9; */
        if (message.displayName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.displayName);
        /* c1.api.action.v1.ActionVisibilityEveryone everyone = 100; */
        if (message.visibility.oneofKind === "everyone")
            ActionVisibilityEveryone.internalBinaryWrite(message.visibility.everyone, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.action.v1.AppEntitlementRefs app_entitlement_refs = 101; */
        if (message.visibility.oneofKind === "appEntitlementRefs")
            AppEntitlementRefs.internalBinaryWrite(message.visibility.appEntitlementRefs, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.action.v1.WorkflowTemplateRef workflow_template_ref = 200; */
        if (message.targetRef.oneofKind === "workflowTemplateRef")
            WorkflowTemplateRef.internalBinaryWrite(message.targetRef.workflowTemplateRef, writer.tag(200, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.action.v1.BatonResourceActionRef baton_resource_action_ref = 201; */
        if (message.targetRef.oneofKind === "batonResourceActionRef")
            BatonResourceActionRef.internalBinaryWrite(message.targetRef.batonResourceActionRef, writer.tag(201, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.Action
 */
export const Action = new Action$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionVisibilityEveryone$Type extends MessageType<ActionVisibilityEveryone> {
    constructor() {
        super("c1.api.action.v1.ActionVisibilityEveryone", []);
    }
    create(value?: PartialMessage<ActionVisibilityEveryone>): ActionVisibilityEveryone {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ActionVisibilityEveryone>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActionVisibilityEveryone): ActionVisibilityEveryone {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActionVisibilityEveryone, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionVisibilityEveryone
 */
export const ActionVisibilityEveryone = new ActionVisibilityEveryone$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkflowTemplateRef$Type extends MessageType<WorkflowTemplateRef> {
    constructor() {
        super("c1.api.action.v1.WorkflowTemplateRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<WorkflowTemplateRef>): WorkflowTemplateRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<WorkflowTemplateRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkflowTemplateRef): WorkflowTemplateRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkflowTemplateRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.WorkflowTemplateRef
 */
export const WorkflowTemplateRef = new WorkflowTemplateRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionRef$Type extends MessageType<ActionRef> {
    constructor() {
        super("c1.api.action.v1.ActionRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ActionRef>): ActionRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ActionRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActionRef): ActionRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActionRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionRef
 */
export const ActionRef = new ActionRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatonResourceActionRef$Type extends MessageType<BatonResourceActionRef> {
    constructor() {
        super("c1.api.action.v1.BatonResourceActionRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "baton_action_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "baton_action_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<BatonResourceActionRef>): BatonResourceActionRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.resourceTypeId = "";
        message.batonActionName = "";
        message.batonActionDisplayName = "";
        if (value !== undefined)
            reflectionMergePartial<BatonResourceActionRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BatonResourceActionRef): BatonResourceActionRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string resource_type_id */ 3:
                    message.resourceTypeId = reader.string();
                    break;
                case /* string baton_action_name */ 4:
                    message.batonActionName = reader.string();
                    break;
                case /* string baton_action_display_name */ 5:
                    message.batonActionDisplayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BatonResourceActionRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string resource_type_id = 3; */
        if (message.resourceTypeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceTypeId);
        /* string baton_action_name = 4; */
        if (message.batonActionName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.batonActionName);
        /* string baton_action_display_name = 5; */
        if (message.batonActionDisplayName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.batonActionDisplayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.BatonResourceActionRef
 */
export const BatonResourceActionRef = new BatonResourceActionRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementRefs$Type extends MessageType<AppEntitlementRefs> {
    constructor() {
        super("c1.api.action.v1.AppEntitlementRefs", [
            { no: 1, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementRefs>): AppEntitlementRefs {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementRefs>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementRefs): AppEntitlementRefs {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementRef refs */ 1:
                    message.refs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementRefs, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementRef refs = 1; */
        for (let i = 0; i < message.refs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.refs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.AppEntitlementRefs
 */
export const AppEntitlementRefs = new AppEntitlementRefs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceCreateRequest$Type extends MessageType<ActionServiceCreateRequest> {
    constructor() {
        super("c1.api.action.v1.ActionServiceCreateRequest", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "request_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "form_schema_ref", kind: "message", T: () => FormSchemaRef },
            { no: 100, name: "everyone", kind: "message", oneof: "visibility", T: () => ActionVisibilityEveryone },
            { no: 101, name: "app_entitlement_refs", kind: "message", oneof: "visibility", T: () => AppEntitlementRefs },
            { no: 200, name: "workflow_template_ref", kind: "message", oneof: "targetRef", T: () => WorkflowTemplateRef },
            { no: 201, name: "baton_resource_action_ref", kind: "message", oneof: "targetRef", T: () => BatonResourceActionRef },
            { no: 4, name: "request_instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ActionServiceCreateRequest>): ActionServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.enabled = false;
        message.requestPolicyId = "";
        message.visibility = { oneofKind: undefined };
        message.targetRef = { oneofKind: undefined };
        message.requestInstructions = "";
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<ActionServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActionServiceCreateRequest): ActionServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* string request_policy_id */ 2:
                    message.requestPolicyId = reader.string();
                    break;
                case /* c1.api.form.v1.FormSchemaRef form_schema_ref */ 3:
                    message.formSchemaRef = FormSchemaRef.internalBinaryRead(reader, reader.uint32(), options, message.formSchemaRef);
                    break;
                case /* c1.api.action.v1.ActionVisibilityEveryone everyone */ 100:
                    message.visibility = {
                        oneofKind: "everyone",
                        everyone: ActionVisibilityEveryone.internalBinaryRead(reader, reader.uint32(), options, (message.visibility as any).everyone)
                    };
                    break;
                case /* c1.api.action.v1.AppEntitlementRefs app_entitlement_refs */ 101:
                    message.visibility = {
                        oneofKind: "appEntitlementRefs",
                        appEntitlementRefs: AppEntitlementRefs.internalBinaryRead(reader, reader.uint32(), options, (message.visibility as any).appEntitlementRefs)
                    };
                    break;
                case /* c1.api.action.v1.WorkflowTemplateRef workflow_template_ref */ 200:
                    message.targetRef = {
                        oneofKind: "workflowTemplateRef",
                        workflowTemplateRef: WorkflowTemplateRef.internalBinaryRead(reader, reader.uint32(), options, (message.targetRef as any).workflowTemplateRef)
                    };
                    break;
                case /* c1.api.action.v1.BatonResourceActionRef baton_resource_action_ref */ 201:
                    message.targetRef = {
                        oneofKind: "batonResourceActionRef",
                        batonResourceActionRef: BatonResourceActionRef.internalBinaryRead(reader, reader.uint32(), options, (message.targetRef as any).batonResourceActionRef)
                    };
                    break;
                case /* string request_instructions */ 4:
                    message.requestInstructions = reader.string();
                    break;
                case /* string display_name */ 5:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActionServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* string request_policy_id = 2; */
        if (message.requestPolicyId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.requestPolicyId);
        /* c1.api.form.v1.FormSchemaRef form_schema_ref = 3; */
        if (message.formSchemaRef)
            FormSchemaRef.internalBinaryWrite(message.formSchemaRef, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string request_instructions = 4; */
        if (message.requestInstructions !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.requestInstructions);
        /* string display_name = 5; */
        if (message.displayName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.displayName);
        /* c1.api.action.v1.ActionVisibilityEveryone everyone = 100; */
        if (message.visibility.oneofKind === "everyone")
            ActionVisibilityEveryone.internalBinaryWrite(message.visibility.everyone, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.action.v1.AppEntitlementRefs app_entitlement_refs = 101; */
        if (message.visibility.oneofKind === "appEntitlementRefs")
            AppEntitlementRefs.internalBinaryWrite(message.visibility.appEntitlementRefs, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.action.v1.WorkflowTemplateRef workflow_template_ref = 200; */
        if (message.targetRef.oneofKind === "workflowTemplateRef")
            WorkflowTemplateRef.internalBinaryWrite(message.targetRef.workflowTemplateRef, writer.tag(200, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.action.v1.BatonResourceActionRef baton_resource_action_ref = 201; */
        if (message.targetRef.oneofKind === "batonResourceActionRef")
            BatonResourceActionRef.internalBinaryWrite(message.targetRef.batonResourceActionRef, writer.tag(201, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceCreateRequest
 */
export const ActionServiceCreateRequest = new ActionServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceCreateResponse$Type extends MessageType<ActionServiceCreateResponse> {
    constructor() {
        super("c1.api.action.v1.ActionServiceCreateResponse", [
            { no: 1, name: "action", kind: "message", T: () => Action }
        ]);
    }
    create(value?: PartialMessage<ActionServiceCreateResponse>): ActionServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ActionServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActionServiceCreateResponse): ActionServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.action.v1.Action action */ 1:
                    message.action = Action.internalBinaryRead(reader, reader.uint32(), options, message.action);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActionServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.action.v1.Action action = 1; */
        if (message.action)
            Action.internalBinaryWrite(message.action, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceCreateResponse
 */
export const ActionServiceCreateResponse = new ActionServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceGetRequest$Type extends MessageType<ActionServiceGetRequest> {
    constructor() {
        super("c1.api.action.v1.ActionServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ActionServiceGetRequest>): ActionServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ActionServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActionServiceGetRequest): ActionServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActionServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceGetRequest
 */
export const ActionServiceGetRequest = new ActionServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceGetResponse$Type extends MessageType<ActionServiceGetResponse> {
    constructor() {
        super("c1.api.action.v1.ActionServiceGetResponse", [
            { no: 1, name: "action", kind: "message", T: () => Action }
        ]);
    }
    create(value?: PartialMessage<ActionServiceGetResponse>): ActionServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ActionServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActionServiceGetResponse): ActionServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.action.v1.Action action */ 1:
                    message.action = Action.internalBinaryRead(reader, reader.uint32(), options, message.action);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActionServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.action.v1.Action action = 1; */
        if (message.action)
            Action.internalBinaryWrite(message.action, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceGetResponse
 */
export const ActionServiceGetResponse = new ActionServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceListRequest$Type extends MessageType<ActionServiceListRequest> {
    constructor() {
        super("c1.api.action.v1.ActionServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActionRef }
        ]);
    }
    create(value?: PartialMessage<ActionServiceListRequest>): ActionServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<ActionServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActionServiceListRequest): ActionServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.action.v1.ActionRef refs */ 3:
                    message.refs.push(ActionRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActionServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.action.v1.ActionRef refs = 3; */
        for (let i = 0; i < message.refs.length; i++)
            ActionRef.internalBinaryWrite(message.refs[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceListRequest
 */
export const ActionServiceListRequest = new ActionServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceListResponse$Type extends MessageType<ActionServiceListResponse> {
    constructor() {
        super("c1.api.action.v1.ActionServiceListResponse", [
            { no: 1, name: "actions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Action },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ActionServiceListResponse>): ActionServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actions = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ActionServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActionServiceListResponse): ActionServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.action.v1.Action actions */ 1:
                    message.actions.push(Action.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActionServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.action.v1.Action actions = 1; */
        for (let i = 0; i < message.actions.length; i++)
            Action.internalBinaryWrite(message.actions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceListResponse
 */
export const ActionServiceListResponse = new ActionServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceUpdateRequest$Type extends MessageType<ActionServiceUpdateRequest> {
    constructor() {
        super("c1.api.action.v1.ActionServiceUpdateRequest", [
            { no: 1, name: "action", kind: "message", T: () => Action, options: { "validate.rules": { message: { required: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<ActionServiceUpdateRequest>): ActionServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ActionServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActionServiceUpdateRequest): ActionServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.action.v1.Action action */ 1:
                    message.action = Action.internalBinaryRead(reader, reader.uint32(), options, message.action);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActionServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.action.v1.Action action = 1; */
        if (message.action)
            Action.internalBinaryWrite(message.action, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceUpdateRequest
 */
export const ActionServiceUpdateRequest = new ActionServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceUpdateResponse$Type extends MessageType<ActionServiceUpdateResponse> {
    constructor() {
        super("c1.api.action.v1.ActionServiceUpdateResponse", [
            { no: 1, name: "action", kind: "message", T: () => Action }
        ]);
    }
    create(value?: PartialMessage<ActionServiceUpdateResponse>): ActionServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ActionServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActionServiceUpdateResponse): ActionServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.action.v1.Action action */ 1:
                    message.action = Action.internalBinaryRead(reader, reader.uint32(), options, message.action);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActionServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.action.v1.Action action = 1; */
        if (message.action)
            Action.internalBinaryWrite(message.action, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceUpdateResponse
 */
export const ActionServiceUpdateResponse = new ActionServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceDeleteRequest$Type extends MessageType<ActionServiceDeleteRequest> {
    constructor() {
        super("c1.api.action.v1.ActionServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ActionServiceDeleteRequest>): ActionServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ActionServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActionServiceDeleteRequest): ActionServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActionServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceDeleteRequest
 */
export const ActionServiceDeleteRequest = new ActionServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceDeleteResponse$Type extends MessageType<ActionServiceDeleteResponse> {
    constructor() {
        super("c1.api.action.v1.ActionServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<ActionServiceDeleteResponse>): ActionServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ActionServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActionServiceDeleteResponse): ActionServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActionServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceDeleteResponse
 */
export const ActionServiceDeleteResponse = new ActionServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceSearchRequest$Type extends MessageType<ActionServiceSearchRequest> {
    constructor() {
        super("c1.api.action.v1.ActionServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActionRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 6, name: "target_ref_type_filter", kind: "message", T: () => ActionTargetRefTypeFilter },
            { no: 7, name: "enabled", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ActionServiceSearchRequest>): ActionServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.refs = [];
        message.appIds = [];
        if (value !== undefined)
            reflectionMergePartial<ActionServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActionServiceSearchRequest): ActionServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.action.v1.ActionRef refs */ 4:
                    message.refs.push(ActionRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string app_ids */ 5:
                    message.appIds.push(reader.string());
                    break;
                case /* c1.api.action.v1.ActionTargetRefTypeFilter target_ref_type_filter */ 6:
                    message.targetRefTypeFilter = ActionTargetRefTypeFilter.internalBinaryRead(reader, reader.uint32(), options, message.targetRefTypeFilter);
                    break;
                case /* optional bool enabled */ 7:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActionServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.action.v1.ActionRef refs = 4; */
        for (let i = 0; i < message.refs.length; i++)
            ActionRef.internalBinaryWrite(message.refs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated string app_ids = 5; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.appIds[i]);
        /* c1.api.action.v1.ActionTargetRefTypeFilter target_ref_type_filter = 6; */
        if (message.targetRefTypeFilter)
            ActionTargetRefTypeFilter.internalBinaryWrite(message.targetRefTypeFilter, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* optional bool enabled = 7; */
        if (message.enabled !== undefined)
            writer.tag(7, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceSearchRequest
 */
export const ActionServiceSearchRequest = new ActionServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionTargetRefTypeFilter$Type extends MessageType<ActionTargetRefTypeFilter> {
    constructor() {
        super("c1.api.action.v1.ActionTargetRefTypeFilter", [
            { no: 1, name: "workflow_template", kind: "message", oneof: "targetRefType", T: () => WorkflowTemplateRefFilter },
            { no: 2, name: "baton_resource_action", kind: "message", oneof: "targetRefType", T: () => BatonResourceActionRefFilter }
        ]);
    }
    create(value?: PartialMessage<ActionTargetRefTypeFilter>): ActionTargetRefTypeFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetRefType = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<ActionTargetRefTypeFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActionTargetRefTypeFilter): ActionTargetRefTypeFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.action.v1.WorkflowTemplateRefFilter workflow_template */ 1:
                    message.targetRefType = {
                        oneofKind: "workflowTemplate",
                        workflowTemplate: WorkflowTemplateRefFilter.internalBinaryRead(reader, reader.uint32(), options, (message.targetRefType as any).workflowTemplate)
                    };
                    break;
                case /* c1.api.action.v1.BatonResourceActionRefFilter baton_resource_action */ 2:
                    message.targetRefType = {
                        oneofKind: "batonResourceAction",
                        batonResourceAction: BatonResourceActionRefFilter.internalBinaryRead(reader, reader.uint32(), options, (message.targetRefType as any).batonResourceAction)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActionTargetRefTypeFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.action.v1.WorkflowTemplateRefFilter workflow_template = 1; */
        if (message.targetRefType.oneofKind === "workflowTemplate")
            WorkflowTemplateRefFilter.internalBinaryWrite(message.targetRefType.workflowTemplate, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.action.v1.BatonResourceActionRefFilter baton_resource_action = 2; */
        if (message.targetRefType.oneofKind === "batonResourceAction")
            BatonResourceActionRefFilter.internalBinaryWrite(message.targetRefType.batonResourceAction, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionTargetRefTypeFilter
 */
export const ActionTargetRefTypeFilter = new ActionTargetRefTypeFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkflowTemplateRefFilter$Type extends MessageType<WorkflowTemplateRefFilter> {
    constructor() {
        super("c1.api.action.v1.WorkflowTemplateRefFilter", []);
    }
    create(value?: PartialMessage<WorkflowTemplateRefFilter>): WorkflowTemplateRefFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WorkflowTemplateRefFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkflowTemplateRefFilter): WorkflowTemplateRefFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkflowTemplateRefFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.WorkflowTemplateRefFilter
 */
export const WorkflowTemplateRefFilter = new WorkflowTemplateRefFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatonResourceActionRefFilter$Type extends MessageType<BatonResourceActionRefFilter> {
    constructor() {
        super("c1.api.action.v1.BatonResourceActionRefFilter", []);
    }
    create(value?: PartialMessage<BatonResourceActionRefFilter>): BatonResourceActionRefFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BatonResourceActionRefFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BatonResourceActionRefFilter): BatonResourceActionRefFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BatonResourceActionRefFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.BatonResourceActionRefFilter
 */
export const BatonResourceActionRefFilter = new BatonResourceActionRefFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActionServiceSearchResponse$Type extends MessageType<ActionServiceSearchResponse> {
    constructor() {
        super("c1.api.action.v1.ActionServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Action },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ActionServiceSearchResponse>): ActionServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ActionServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActionServiceSearchResponse): ActionServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.action.v1.Action list */ 1:
                    message.list.push(Action.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActionServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.action.v1.Action list = 1; */
        for (let i = 0; i < message.list.length; i++)
            Action.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.action.v1.ActionServiceSearchResponse
 */
export const ActionServiceSearchResponse = new ActionServiceSearchResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.action.v1.ActionService
 */
export const ActionService = new ServiceType("c1.api.action.v1.ActionService", [
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: ActionServiceCreateRequest, O: ActionServiceCreateResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: ActionServiceGetRequest, O: ActionServiceGetResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: ActionServiceListRequest, O: ActionServiceListResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: ActionServiceUpdateRequest, O: ActionServiceUpdateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: ActionServiceDeleteRequest, O: ActionServiceDeleteResponse },
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: ActionServiceSearchRequest, O: ActionServiceSearchResponse }
]);
